import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { MatDividerModule } from '@angular/material/divider';
import { UploadFileComponent } from '../upload-file/upload-file.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-card-detail',
  standalone: true,
  imports: [
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    UploadFileComponent,
  ],
  template: `
    <div class="container-fluid">
      <div class="card w-100 border-0">
        <div class="card-body">
          <div class="row header-row">
            <div class="col-auto d-none d-md-flex">
              <ng-content select="[card-title]"></ng-content>
            </div>
            <!-- SEARCH COMPONENT -->
            <div class="col text-end lex-grow-1">
              <ng-content select="[card-search-action]"></ng-content>
            </div>
            <!-- BUTTONS -->
            <div class="col-auto d-none d-md-flex text-end">
              <ng-content select="[card-actions]"></ng-content>
              @if (showCloseButton) {
              <button mat-icon-button (click)="closeDetail()">
                <mat-icon svgIcon="close" class="d-flex"></mat-icon>
              </button>
              }
            </div>
            <!-- ADD BTN SMALL DEVICE-->
            <div class="col-auto d-flex d-md-none text-end">
              <ng-content select="[card-sm-actions]"></ng-content>
            </div>

            @if (showHeaderDivider) {
            <mat-divider class="mt-2"></mat-divider>
            }
          </div>
          <div class="row mt-3">
            <ng-content select="[card-content]"></ng-content>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class CardDetailComponent {
  @Input() showHeaderDivider = false;
  @Input() showCloseButton = true;
  @Output() closeEvent = new EventEmitter<boolean>();

  closeDetail(): void {
    this.closeEvent.emit(true);
  }
}
